import React, { Component } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";

class DateComponent extends Component {
  constructor() {
    super();
    this.state = {
      startDate: null,
    };
    this.setStartDate = this.setStartDate.bind(this);
  }

  setStartDate(date) {
    this.setState({ startDate: date });
    this.props.getDate(date);
  }

  render() {
    const { startDate } = this.state;
    const {
      className,
      containerClassName,
      labelText,
      ...otherProps
    } = this.props;
    return (
      <div className={containerClassName}>
        <div className="wc-date-label">{labelText}</div>
        <DatePicker
          className={className}
          selected={startDate}
          onChange={date => this.setStartDate(date)}
          {...otherProps}
        />
      </div>
    );
  }
}

DateComponent.defaultProps = {
  className: "",
  labelText: "",
  containerClassName: "",
};

DateComponent.propTypes = {
  getDate: PropTypes.func.isRequired,
  className: PropTypes.string,
  labelText: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default DateComponent;
